import React, { useState } from 'react';
import '../styles/Home.css';
import '../styles/Review.css';
import { FaEnvelope, FaMapPin, FaPhone } from 'react-icons/fa';
import { FaChevronLeft, FaChevronRight, FaFacebook, FaGlobe, FaInstagram } from 'react-icons/fa6';
import { Link } from 'react-router-dom';

export default function Review() {

    // const [ review, setReview ] = useState({
    //     id: 1,
    //     type: 'hotel',
    //     title: 'Royal Torarica',
    //     contact: {
    //         address: 'Kleine Waterstraat 10, Paramaribo Suriname',
    //         phone: '+597 473-500',
    //         email: 'contact@toraricagroup.com',
    //         website: 'https://royaltorarica.com/',
    //     },
    //     socials: {
    //         instagram: {
    //             handle: '@royaltorarica_',
    //             url: 'https://www.instagram.com/royaltorarica_/?hl=en'
    //         },
    //         facebook: {
    //             handle: 'RoyalTorarica',
    //             url: 'https://www.facebook.com/RoyalTorarica/'
    //         }
    //     },
    //     amenities: [
    //         {
    //             id: 1,
    //             amenity: 'Free Wifi',
    //         },
    //         {
    //             id: 2,
    //             amenity: 'Outdoor Pool',
    //         },
    //         {
    //             id: 3,
    //             amenity: 'Fitness Center',
    //         },
    //         {
    //             id: 4,
    //             amenity: 'Spa Services',
    //         },
    //         {
    //             id: 5,
    //             amenity: 'Conference Rooms',
    //         },
    //         {
    //             id: 6,
    //             amenity: 'On-Site Dining',
    //         },
    //         {
    //             id: 7,
    //             amenity: '24/7 Room Service',
    //         },
    //         {
    //             id: 8,
    //             amenity: 'Airport Shuttle',
    //         },
    //         {
    //             id: 9,
    //             amenity: 'Business Center',
    //         },
    //         {
    //             id: 10,
    //             amenity: 'Concierge Services',
    //         }
    //     ],
    //     content: `<bold>Overview</bold> <br/><br/>
    //         Royal Torarica is considered one of the most luxurious hotels in Paramaribo, Suriname. 
    //         Situated in the heart of the city’s entertainment district, it offers a blend of modern 
    //         comfort and Surinamese hospitality. Its central location makes it a prime spot for tourists, 
    //         business travelers, and locals looking for a refined stay. <br/><br/>
    //         Guests at Royal Torarica can enjoy a wide array of amenities, including an expansive 
    //         outdoor pool surrounded by lush gardens, a state-of-the-art fitness center, and 
    //         rejuvenating spa services. The hotel also features a fine-dining restaurant that serves 
    //         both international and local dishes, along with an elegant lounge for cocktails and light snacks. 
    //         <br/><br/>
    //         For business travelers, the hotel provides fully equipped conference rooms and a dedicated 
    //         business center. With its exceptional service, modern facilities, and a commitment to excellence, 
    //         Royal Torarica ensures a memorable experience for all its guests.`,
    //     more: [
    //         {
    //             id: '1',
    //             type: 'restaurant',
    //             name: "Orchid",
    //             image: 'https://royaltorarica.com/uploads/images/page-blocks/crop_large/orchid-interior-08.jpg',
    //             about: 'We do our utmost to make every visit of our valued guests unforgettable. When it comes to our service, we always go the extra mile for our guests. We often surprise them with new, innovative and refreshing selections in our menus. In Suriname, we know a thing or two about good food. That’s why, in our restaurant, we spoil you with the tastiest dishes.'
    //         },
    //         {
    //             id: '2',
    //             type: 'restaurant',
    //             name: "Chi Min",
    //             image: 'https://royaltorarica.com/uploads/images/page-blocks/crop_large/orchid-interior-08.jpg',
    //             about: 'We do our utmost to make every visit of our valued guests unforgettable. When it comes to our service, we always go the extra mile for our guests. We often surprise them with new, innovative and refreshing selections in our menus. In Suriname, we know a thing or two about good food. That’s why, in our restaurant, we spoil you with the tastiest dishes.'
    //         },
    //     ]
    // });

    const [review, setReview] = useState({
        id: 2,
        type: 'hotel',
        title: 'The Rif at Mangrove Beach Corendon All-Inclusive, Curio Collection by Hilton',
        contact: {
            address: 'Pater Euwensweg 31A, Willemstad, Curaçao',
            phone: '+599 9 433 3333',
            email: 'info@corendonhotels.com',
            website: 'https://www.hilton.com/en/hotels/curmgqq-the-rif-at-mangrove-beach-corendon-curacao-all-inclusive/'
        },
        socials: {
            instagram: {
                handle: '@corendonhotels',
                url: 'https://www.instagram.com/corendonhotels/'
            },
            facebook: {
                handle: 'CorendonHotels',
                url: 'https://www.facebook.com/CorendonHotels/'
            }
        },
        amenities: [
            { id: 1, amenity: 'Free Wi-Fi' },
            { id: 2, amenity: 'Outdoor Pool' },
            { id: 3, amenity: 'Fitness Center' },
            { id: 4, amenity: 'Spa Services' },
            { id: 5, amenity: 'Private Beach' },
            { id: 6, amenity: 'On-Site Dining' },
            { id: 7, amenity: '24/7 Room Service' },
            { id: 8, amenity: 'Conference Rooms' },
            { id: 9, amenity: 'Concierge Services' },
            { id: 10, amenity: 'Airport Shuttle' }
        ],
        content: `<bold>Overview</bold> <br/><br/>
            The Rif at Mangrove Beach Corendon All-Inclusive, Curio Collection by Hilton, is a luxurious beachfront resort located in Willemstad, Curaçao. Surrounded by the Caribbean Sea and lush mangrove forests, the resort offers an all-inclusive experience just two kilometers from the vibrant city center. Guests can enjoy modern accommodations with floor-to-ceiling glass doors, some featuring spacious balconies or swim-up terraces. The resort boasts a private beach, outdoor pool, and access to family-friendly amenities at the adjacent sister resort. With four diverse restaurants and two bars, guests are treated to a variety of culinary delights. Additionally, the resort provides facilities for events, making it an ideal destination for both leisure and business travelers.`,
        more: [
            {
                id: '1',
                type: 'restaurant',
                name: 'All-Day Buffet Restaurant',
                image: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/655513834.jpg?k=164d4bfbd237e2e94d767ccb946fd6e35165d68201ede077b10da557b53069dc&o=&hp=1',
                about: 'Enjoy a wide variety of international dishes served throughout the day in a relaxed setting.'
            },
            {
                id: '2',
                type: 'restaurant',
                name: 'Stylish Bistro',
                image: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/655513893.jpg?k=5caf8fe53d3d0444dafdebc3360a2bc68b9b7581b191a52d5163926c64bb68e0&o=&hp=1',
                about: 'Experience gourmet dining with a menu featuring local and international cuisine in an elegant atmosphere.'
            },
            {
                id: '3',
                type: 'bar',
                name: '24-Hour Beach Bar',
                image: 'https://cf.bstatic.com/xdata/images/hotel/max1024x768/655511381.jpg?k=38d3ce52338915ca386ad941476a079d39bf97ddceaebb6ff73c52883186857c&o=&hp=1',
                about: 'Relax with refreshing cocktails and light snacks at our beachside bar, open all day and night.'
            }
        ]
    });

    const [currentIndex, setCurrentIndex] = useState(0);

    const nextSlide = () => {
        setCurrentIndex((prev) => (prev + 1) % review.more.length);
    };

    const prevSlide = () => {
        setCurrentIndex((prev) => (prev - 1 + review.more.length) % review.more.length);
    };

  return (
    <div style={{paddingTop:'90px'}}>
        <div className='container'>
            <div className='sponsored-banner'></div>
            <div className='sponsored-title'>Sponsored banner</div>
        </div>

        <div className='container'>
            <div className='review-header'>
                <div className='review-header-info'>
                    <div className='review-title'>{review.title}</div>
                    <div className='hotel-location'>
                        <FaMapPin size={12} color={'#2c2c2c'} /> 
                        <div className='hotel-address'>{review.contact.address.toUpperCase()}</div>
                    </div>
                </div>

                <Link className='review-header-btn' to={'https://www.expedia.com/Willemstad-Hotels-The-Rif-At-Mangrove-Beach-Corendon-All-Inclusive.h99558527.Hotel-Information?chkin=2025-03-08&chkout=2025-03-09&x_pwa=1&rfrr=HSR&pwa_ts=1741373081968&referrerUrl=aHR0cHM6Ly93d3cuZXhwZWRpYS5jb20vSG90ZWwtU2VhcmNo&useRewards=false&rm1=a2&regionId=937&destination=Willemstad%2C+Cura%C3%A7ao&destType=MARKET&selected=40394671&latLong=12.1%2C-68.92&sort=RECOMMENDED&top_dp=299&top_cur=USD&userIntent=&selectedRoomType=323631933&selectedRatePlan=392384345&searchId=8e50d092-51c7-4aa5-b3e1-cac55dbdc7c5'}>
                    Book Now
                </Link>
            </div>
        </div>

        <div className='review-images-container' style={{backgroundImage: `url('https://www.americanexpress.com/en-us/travel/discover/photos/483034/122606/1600/1.jpg?ch=560')`}}>

        </div>

        <div className='container'>
            <div className='review-content-splitter'>
                <div className='review-content'>
                    <div className='review-amenities'>
                        <div className='review-amenities-title'>AMMENITIES</div>
                        <div className='review-amenities-container'>
                            {review.amenities.map((am, index) => {
                                return (
                                    <div className='ammenity'>
                                        {am.amenity}
                                    </div>
                                )
                            })}
                        </div>
                    </div>

                    <div className='review-amenities-title'>Overview</div>
                    <div
                        style={{letterSpacing: '1px', fontSize: 14, color: '#2e2e2e', marginBottom: 50}}
                        dangerouslySetInnerHTML={{
                            __html: review.content
                                // remove the inline heading and the two line breaks after it
                                .replace(/<bold>\s*Overview\s*<\/bold>\s*<br\s*\/>\s*<br\s*\/>/i, '')
                                // normalize any remaining <bold> tags to <strong>
                                .replace(/<bold>/g, '<strong>')
                                .replace(/<\/bold>/g, '</strong>')
                        }}
                    />

                    <div className='review-amenities-title'>The Magic</div>
                    <div style={{letterSpacing: '1px', fontSize: 14, color: '#2e2e2e', marginBottom: 30}}>
                        From sunrise hues washing over private coves to lantern-lit pathways that wind through lush gardens, this property hums with a quiet wonder. Thoughtful touches—from locally crafted welcome treats to sunset rituals by the water—make every moment feel personal and unforgettable.
                    </div>

                    <div className='review-amenities-title'>Mood</div>
                    <div style={{letterSpacing: '1px', fontSize: 14, color: '#2e2e2e', marginBottom: 40}}>
                        Effortlessly chic and warmly relaxed. Expect a laid-back island vibe with polished service, soulful design details, and spaces that invite both connection and calm—perfect for couples, close friends, and solo travelers seeking ease with style.
                    </div>

                    <div className='review-amenities-title'>Also found in {review.title}</div>        

                    <div className='review-content-more'>
                        <div className='review-content-more-btn' onClick={() => {
                            prevSlide();
                        }}>
                            <FaChevronLeft size={16} color='#fff'/>
                        </div>

                        <div className='review-content-more-main' style={{ transform: `translateX(-${currentIndex * 100}%)` }}>

                            { review.more.map((item, index) => {

                                return (
                                    <div className='review-content-more-item'>
                                        <div className='review-content-more-item-image' style={{backgroundImage: `url(${item.image})`}}/>
                                        <div className='review-content-more-item-info'>
                                            <div className='review-content-more-item-info-title'>{item.name}</div>
                                            <div className='review-content-more-item-info-sub'>{item.about}</div>
                                        </div>
                                    </div>
                                )

                            })

                            }
                        </div>

                        <div className='review-content-more-btn-alt' onClick={() => {
                            nextSlide();
                        }}>
                            <FaChevronRight size={16} color='#fff'/>
                        </div>
                    </div>
                </div>
                <div className='review-side-content'>
                    <div className='review-location-title'>HOTEL LOCATION</div>
                    <div className='review-location-map'></div>

                    <div className='review-contact-title'>CONTACT INFORMATION</div>
                    <div className='review-contact-item'>
                        <FaPhone size={16} color='#2c2c2c'/>
                        <div className='review-contact-text'>{review.contact.phone}</div>
                    </div>
                    <div className='review-contact-item'>
                        <FaEnvelope size={16} color='#2c2c2c'/>
                        <div className='review-contact-text'>{review.contact.email}</div>
                    </div>
                    { (review.contact.website) &&
                        <div className='review-contact-item'>
                            <FaGlobe size={16} color='#2c2c2c'/>
                            <div className='review-contact-text'>{review.contact.website}</div>
                        </div>
                    }   

                    <div className='review-contact-title'>SOCIAL MEDIA</div>
                    <a className='review-contact-item' href={review.socials.instagram.url} target='_blank'>
                        <FaInstagram size={16} color='#2c2c2c'/>
                        <div className='review-contact-text'>{review.socials.instagram.handle}</div>
                    </a>
                    <a className='review-contact-item' href={review.socials.facebook.url} target='_blank'>
                        <FaFacebook size={16} color='#2c2c2c'/>
                        <div className='review-contact-text'>{review.socials.facebook.handle}</div>
                    </a>
                    
                </div>
            </div>
        </div>
        
    </div>
  )
}
